import { RemoteId } from '@moodys/cre-cpm.models.micro-frontends';

export const getMicrofrontends = (): RemoteId[] => [
  'platformApp',
  'mapApp',
  'sidebarApp',
  'quicksightApp',
  'ingestionWorkflowsApp',
  'opexApp',
  'loansApp',
  'notificationCenterApp',
  'globalFiltersApp',
  'assistantApp',
];
